import React, { useEffect, useState } from "react";
import Popup from "../ui/Popup";
import Menu from "../ui/Menu";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";
import { createModal } from "../hooks/createModal";
import Input from "../ui/Input";


export const os_stats = [
    { value: "AVAI", label: "AVAI - Available stock" },
    { value: "BOS", label: "BOS - B/O Out of Stock" },
    { value: "BNYP", label: "BNYP - B/O Not Yet Pub" },
    { value: "BRP", label: "BRP - B/O Reprinting" },
    { value: "BITO", label: "BITO - B/O Import To Order" },
    { value: "COS", label: "COS - Cancel O/S" },
    { value: "CNYP", label: "CNYP - Cancel Not Yet Pub" },
    { value: "CNOP", label: "CNOP - Cancel Not Our Pub" },
    { value: "CNR", label: "CNR - Cancel No Rights" },
    { value: "COP", label: "COP - Cancel Out of Print" },
    { value: "CNL", label: "CNL - Cancel No Listing" },
    { value: "CNW", label: "CNW - Cancel No word" },
    { value: "COSI", label: "COSI - Cancel O/S Indef." },
    { value: "CPXL", label: "CPXL - Cancel Publication" },
    { value: "CRP", label: "CRP - Cancel Reprinting." },
    { value: "CITO", label: "CITO - Cancel Imp to Order" },
    { value: "CBU", label: "CBU - Cancel By Us" },
    { value: "CBC", label: "CBC - Cancel By Cust" }
]

export default function Picker(props) {

    const { controller = "", searchValue = false, showSearch = false, noFilter = false, callback = () => { }, top = false, hide_header = false, autocomplete = false, value = "", allow_keys = false, show_keys = false, popup = true, height = null, width = null, route = "", options = [], defaultValue = "", title = "", description = "", closeable = false } = props;
    const [selected, setSelected] = useState(options.find(item => item.value === value)?.value || defaultValue);
    const [filter, setFilter] = useState("");




    const actions = [
        {

            key: KBD.TAB, action: (e) => { callback({ next: true }); },
            key: KBD.SHIFT_TAB, action: (e) => { callback({ prev: true }); },
            key: KBD.ARROW_LEFT, action: (e) => { callback({ prev: true }); },
            key: KBD.ARROW_RIGHT, action: (e) => { callback({ next: true }); },
            key: KBD.ANY, action: (e) => {


                if (e.key === KBD.SHIFT.key) {
                    return;
                }

                if ((e.key === KBD.TAB.key && !e.shiftKey) || e.key === KBD.ARROW_RIGHT.key) {

                    callback({ next: true });
                    return;
                }

                if ((e.key === KBD.SHIFT_TAB.key && e.shiftKey) || e.key === KBD.ARROW_LEFT.key) {


                    callback({ prev: true });
                    return;
                }


                if (e.key === KBD.ESCAPE.key) {

                    callback(false);
                    return;
                }

                if (e.key === KBD.ENTER.key) {
                    if (options.find(item => item.value === selected)?.disabled) {
                        return;
                    }
                    callback(selected);
                    return;
                }

                if (e.key === "Backspace" && filter.length > 0) {
                    setFilter(filter.slice(0, -1));
                    return;
                }
                const regex = /^[a-z0-9]$/i;
                if (regex.test(e.key) && e.key.length === 1) {
                    setFilter(filter + e.key);
                }


            }
        },
    ]



    useEffect(() => {
        const cleanup = listen(controller, route, actions, false, [KBD.ESCAPE, KBD.ENTER, KBD.ARROW_RIGHT]);
        return cleanup;
    }, [actions, filter])


    const menu = options.filter(item => {

        if (autocomplete) {
            return (item.label.toUpperCase().startsWith(filter.toUpperCase()))
        } else {
            return true;
        }


    }).map(item => {
        let _i = { ...item };
        _i.text = _i.label;
        _i.action = () => callback(_i.value);
        return _i;
    })


    return (<><Popup hide_header={hide_header} className={(popup) ? (top) ? "ui-popup popup-above" : "ui-pop-up" : (top) ? "popup-above" : ""} closable={closeable} description={description} title={(autocomplete && filter) ? <div style={{ "maxWidth": (width) ? width + "px" : "auto", "overflow": "hidden" }}><nobr><em>Search: </em><span style={{ "color": "var(--text-light)" }}>{filter}</span></nobr></div> : title} width={"auto"} callback={callback} component={<Menu controller={controller} searchValue={searchValue} showSearch={showSearch} height={height} width={width} allow_keys={allow_keys} keyName="value" show_keys={show_keys} route={route} menu={menu} selected={selected} setSelected={setSelected} callback={(e) => callback(e.value)} />} /></>)
}

export const drawPicker = ({ controller = "", showSearch = false, searchValue = false, noFilter = false, onNext = false, onPrev = false, align = "top", mask_close = false, top = false, ref = null, allow_keys = false, show_keys = false, autocomplete = false, height = null, width = null, value = "", offset = [0, 0], title = "", description="", closeable = false, options = [], route = "", callback = () => { }, close = () => { } }) => {


    if (ref) {
        ref?.blur();
    }


    if (options.length === 0) { return; }
    // reformat flat array
    let _options = options;
    if (!options[0].hasOwnProperty("value")) {
        _options = options.map(item => {
            return { label: item, value: item }
        })
    }

    window.bm_state.value = ROUTES.HELPERS.PICKER;
    createModal({
        offset: offset,
        className : (noFilter) ? "no-filter" : "",
        title: (ref) ? null : title,
        zIndex: "1002",
        mask_close: mask_close,
        align: align,
        component: <Picker controller={controller} searchValue={searchValue} showSearch={showSearch} align={align} width={width} top={top} mask_close={mask_close} autocomplete={autocomplete} popup={(ref)} allow_keys={allow_keys} show_keys={show_keys} height={height} options={_options} value={value} title={(ref) ? title : ""} description={description} route={ROUTES.HELPERS.PICKER} />, refElement: ref, closable: closeable,

        callback: (e) => {


            ref?.focus();
            if (e?.next) {

                if (onNext) {
                    onNext();
                } else {
                    callback(false);
                }

                return;
            }

            if (e?.prev) {

                if (onPrev) {
                    onPrev();
                } else {
                    callback(false);
                }
                return;
            }

            if (e || e === 0) { callback(e); } else {
                close();
            }
            if(route) {
                window.bm_state.value = route;
            }
        }
    });
}